module.exports = __webpack_public_path__ + "img/indexnew_banner.6f52eecb.png";